import React from 'react';
import PropTypes from 'prop-types';

import { Box } from '@mui/material';

const TunnelContainer = props => {
    const { children } = props;

    return (
        <Box
            id="tunnel-container"
            sx={theme => ({
                width: '100%',
                height: '100%',
                paddingTop: `${theme.constants.phaseBarHeight}px`,
                overflow: 'hidden',
                display: 'flex',
            })}
        >
            {children}
        </Box>
    );
};

TunnelContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

export default TunnelContainer;
